import React from "react";
export function SiteFooter() {
  return <footer className="border-t border-line" data-id="element-83" data-mp="1dqrovx7i9m8c">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-8 text-sm text-muted md:flex-row md:justify-between md:gap-10" data-id="element-84" data-mp="3r7pvfrtcs52e">
        <p data-id="element-85" data-mp="3mg83ft9b5etk">
          © 2026 Sklunx Krushers™, a brand on{" "}
          <a href="https://sklunx.com" className="font-medium text-ink underline underline-offset-4" data-id="element-86" data-mp="3hizm1uvzhetd">SKLUNX.com</a>. Factory costs are from a real quote. Prices are planning estimates.
        </p>
        <p className="md:max-w-sm md:text-right" data-id="element-87" data-mp="38i1e51ifcn5i">Not a medical device. Some medications shouldn't be crushed, so check with a pharmacist first.</p>
      </div>
    </footer>;
}